import { SelfCheckout } from '@formunauts/self-checkout/domain';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export const DonorDeviceSignalStore = signalStore(
  withState<SelfCheckout.DonorDevice>(() => ({
    languages: [],
    locale: '',
  })),
  withMethods((store) => ({
    setLanguages(...newLanguages: string[]): void {
      patchState(store, { languages: newLanguages });
    },
    setLocale(newLocale: string): void {
      patchState(store, { locale: newLocale });
    },
  })),
);
